import { useSelector } from "react-redux";

const IngramOrdersHappi = () => {
  const OrgId = useSelector((state) => state.auth.org_id);
    return (
      <div className="">
          <iframe src={`https://iiplwork.retool.com/embedded/public/a51c1550-64df-4f89-ac19-9c0d1b2fa119`}
          className="iframe-style"></iframe>
      </div>
  
    )
  };
  
  export default IngramOrdersHappi;
  